import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  GetAgeSexRisk,
  AddAgeSexRisk,
  UpdateAgeSexRisk,
  DeleteAgeSexRisk,
} from "../../../../api/User/ACG/AgeSexRiskApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  age: Yup.number()
    .min(0, "Age must be positive")
    .integer("Age must be an integer")
    .typeError("Please enter a valid number")
    .required("Please enter age"),
  age_Group: Yup.string().required("Please enter age group"),
  gender: Yup.string()
    .notOneOf(["Select Gender"], "Please select gender")
    .required("Please select gender"),
  ageSex_Risk_Percentile: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ageSex risk"),
});

const AgeSexRisk = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [isGetData, setIsGetData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Age", field: "age" },
    { title: "Age Group", field: "age_Group" },
    { title: "Gender", field: "gender" },
    {
      title: "AgeSex Risk Percentile",
      field: "ageSex_Risk_Percentile",
      render: (rowData) => (+rowData.ageSex_Risk_Percentile * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.ageSex_Risk_Percentile * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getIndustryRiskData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getIndustryRiskData();
  }, []);

  const getIndustryRiskData = () => {
    setIsLoading(true);
    GetAgeSexRisk()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { age, age_Group, gender, ageSex_Risk_Percentile } = values;
    const payload = {
      id: 0,
      age: +age,
      age_Group,
      gender,
      ageSex_Risk_Percentile: +ageSex_Risk_Percentile,
    };

    if (witchAction === "add") {
      AddAgeSexRisk(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateAgeSexRisk({ ...payload, id: selectedRowData.id }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            AgeSex Risk
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteAgeSexRisk(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                age: selectedRowData?.age ?? 0,
                age_Group: selectedRowData?.age_Group ?? "",
                gender: selectedRowData?.gender ?? "Select Gender",
                ageSex_Risk_Percentile: selectedRowData?.ageSex_Risk_Percentile ?? 0
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <CustomInputField
                      label="Age"
                      name="age"
                      maxLength={3}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Age Group"
                      name="age_Group"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Gender <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.label}
                        name="gender"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.gender && errors.gender}
                      >
                        {["Select Gender", "M", "F"].map((item) => (
                          <option
                            value={item}
                            selected={values.gender === item}
                          >
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.gender}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <CustomInputField
                      label="AgeSex Risk Percentile"
                      name="ageSex_Risk_Percentile"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add New AgeSex Risk
        </CustomButton>
      </div>
      <CustomMaterialTable
        isExport={true}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AgeSexRisk;
